var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9999 19C15.4182 19 18.9999 15.4183 18.9999 11C18.9999 6.58172 15.4182 3 10.9999 3C6.58161 3 2.99988 6.58172 2.99988 11C2.99988 12.4377 3.37913 13.7868 4.04303 14.9528L2.59717 18.6788L6.21016 17.4083C7.54545 18.4079 9.20353 19 10.9999 19ZM10.0801 9.91687C10.0801 10.421 10.4926 10.8335 10.9967 10.8335C11.5009 10.8335 11.9134 10.421 11.9134 9.91687V8.08354C11.9134 7.57937 11.5009 7.16687 10.9967 7.16687C10.4926 7.16687 10.0801 7.57937 10.0801 8.08354V9.91687ZM10.0801 14.5002H11.9134V12.6669H10.0801V14.5002Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentWarningIcon);
export default __webpack_public_path__ + "static/media/CommentWarningIcon.10947946b2d8053cb783b4aef9c6e6c7.svg";
export { ForwardRef as ReactComponent };